import { useQuery } from 'react-query';
import RestHttpClient from '../../../common/RestHttpClient';
import { ActiveContractFilter } from '../../../generated/ApiClient';

export const dashboardActiveContractsQueryKey = (showAll: boolean) =>
  ['dashboard', 'activeContracts', showAll] as const;

export function useActiveContractsQuery(showAll: boolean) {
  return useQuery({
    queryKey: dashboardActiveContractsQueryKey(showAll),
    queryFn: async () => {
      const { data } = await RestHttpClient.getActiveContracts(showAll, ActiveContractFilter.All);
      return data;
    },
    keepPreviousData: true,
    staleTime: 60_000,
  });
}
